import { mutateGraphQL } from '~/hooks/graphql.js';

const passwordProtectedAccessMutationQuery = `
  mutation PasswordProtectedAccess(
    $postId: Int!
    $password: String!
    $captchaToken: String!
  ) {
    passwordProtectedAccess(input: {
      postId: $postId
      password: $password
      captchaToken: $captchaToken
    }) {
      status
    }
  }
`;

/**
 * If the correct password is entered for the password protected post, then the wp cookie 'wp-postpass_' will be set in the browser.
 *
 */
export async function passwordProtectedAccessMutation ({ postId, password, captchaToken }) {
  const { mutationHandler } = mutateGraphQL(passwordProtectedAccessMutationQuery);

  return await mutationHandler({ postId, password, captchaToken });
}
